import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

import '../../common/common.min.css'
import commonApi from '../../common/common'
Vue.prototype.$commonApi = commonApi

import router from './router/index'
router.afterEach(function (to) {
  window.scrollTo(0, 0)
})

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)
import 'ant-design-vue/dist/antd.css';
import {Form, Input, Checkbox, Button, Radio, DatePicker, message} from 'ant-design-vue'
Vue.use(Form)
Vue.use(Input)
Vue.use(Checkbox)
Vue.use(Button)
Vue.use(Radio)
Vue.use(DatePicker)
Vue.prototype.$message = message;

import myStore from '../src/router/store'
Vue.prototype.$myStore = myStore

import Cookies from 'vue-cookies'
Vue.use(Cookies)

new Vue({
  render: h => h(App),
  router,
  sharedState: myStore.state
}).$mount('#app')